import { Component, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { CartService } from '../services/cart.service';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-asa-form',
  standalone: false,
  templateUrl: './asa-form.component.html',
  styleUrl: './asa-form.component.scss'
})
export class AsaFormComponent {
  objects: any; // will be of objects with value, type, and parent
  changes = [
    { value: 'something.com', type: 'fqdn', changeTo: 'big_Group', changeType: '+' },
    { value: "10.21.31.198", type: "host", changeTo: 'big_Group', changeType: '-' },
    { value: "10.6.31.201", type: "host", changeTo: 'testGroup', changeType: '+' },
    { value: "10.6.9.43", type: "host", changeTo: 'big_Group', changeType: '-' },
    { value: "10.6.9.46", type: "host", changeTo: 'testGroup', changeType: '+' },
    { value: "fake_group", type: "group", changeTo: 'testGroup', changeType: '-' },
    { value: "new_group", type: "group", changeTo: '', changeType: '+' },
    { value: "a_random_group", type: "group", changeTo: 'big_Group', changeType: '+' }
  ]

  hasStartingParent = false;
  startingParent = {
    value: '',
    type: 'group',
    parent: '',
    children: []
  };
  description = '';
  user: any;
  errorMessage = '';
  private invalidObjects = new Set<any>();
  private readonly allowedObjectTypes = new Set(['fqdn', 'host', 'subnet', 'range', 'group']);

  // Some notes
  // All objects get added under a group object.
  // Group objects can be nested in another group object
  // FQDNs specifically are a "group" of sorts but only have one value. So I will work out a script to take the change cart and turn it into a cli for the asa.
  // So every object just needs to be linked to its parent.
  // Of creating a group object (a parent) then that is the only item that doesn't "have" to be added to a group by requirement.

  missingFields = new Set<string>();

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public dataIn: any,
    private _cart: CartService, 
    private _user: UserService,
    @Optional() public dialogRef?: MatDialogRef<AsaFormComponent>
  ) { }

  ngOnInit() {
    this._user.user$.subscribe(user => {
      if (user && user !== null) {
        this.user = user;
      }
    });

    // Sort changes so by changeTo ascending, group type before other types, add before remove
    this.changes.sort((a, b) => {
      if (a.changeTo < b.changeTo) return -1;
      if (a.changeTo > b.changeTo) return 1;
      if (a.type === 'group' && b.type !== 'group') return -1;
      if (a.type !== 'group' && b.type === 'group') return 1;
      if (a.changeType === 'add' && b.changeType === 'remove') return -1;
      if (a.changeType === 'remove' && b.changeType === 'add') return 1;
      return 0;
    });

    // This form can be opened with data from a change control, data for changes with no change control, or empty
    if (this.dataIn) {
      console.log('Asa Form initialized with data:', this.dataIn);
      // Creating new objects from view page
      if (this.dataIn.groupName) {
        // Creating new objects from view page
        this.startingParent.value = this.dataIn.groupName;
        this.startingParent.children = [];
        this.hasStartingParent = true;
        this.objects = [];
        this.description = this.dataIn.itemDescription || '';

      } else {
        // Editing existing objects from cart
        // Need to decode data in objects format to edit
        this.objects = this.dataIn.cliConfig;
        this.description = this.dataIn.itemDescription || '';

        console.log('Parsed objects:', this.objects);
        console.log('Parsed object[0]:', this.objects[0].parent);

        this.startingParent.value = this.objects[0].parent;
        this.startingParent.children = this.objects;
        console.log('Starting parent:', this.startingParent);
        this.hasStartingParent = true;
      }
      
    } else {
      let data = {
        "asms": {
          "OpsOwner": "Michael Mason",
          "acronym": "VMWH",
          "altInnovationOwner": "Robert Garza",
          "altOpsOwner": null,
          "altbusinessowner": "Michael Coulthard",
          "appDescription": "VMware Horizon provides end users access to all of their virtual desktops, applications, and online services through a single digital workspace. ** This ASMS entry is only for the solutions being implemented in GM Manufacturing sites **",
          "appStatus": "Active",
          "applicationName": "VMware Horizon for Manufacturing",
          "asmsID": "103237",
          "businessOwner": "Aaron Dunlap",
          "groupName": "103237_vmwh_ip",
          "innovationOwner": "Anu Rajesh",
          "owningCIO": "Kercheville"
        },
        "memberObjects": [
          { "value": "10.21.31.198", type: "host" },
          { "value": "10.6.31.201", type: "host" },
          { "value": "10.6.9.43", type: "host" },
          { "value": "10.6.9.46", type: "host" },
        ],
        "memberGroups": [
          { "value": "103237_vmwh_FAKE", type: "group" }
        ],
        "groupName": "103237_vmwh_ip"
      }
      console.error('Testing Mode, asa form data hard coded', data);
      this.objects = [];
      this.objects.push(data);
      this.ensureInitialTrailingBlanks();
    }
  }

  // getChildren(parent: any) {
  //   console.log('Getting children for parent:', parent);
  //   // This function should return the children of the parent object
  //   return this.objects.filter((obj: any) => obj.parent === parent);
  // }

  submit() {
    this.errorMessage = '';
    this.invalidObjects.clear();

    if (!this.user || !this.user.gmid) {
      this.errorMessage = 'User information is missing. Please sign in again or reload the page.';
      return;
    }

    if (!this.objects || !this.objects.length) {
      this.errorMessage = 'Add at least one object or group before saving to the cart.';
      return;
    }

    const validationErrors = this.validateObjects(this.objects);
    if (validationErrors.length) {
      this.errorMessage = validationErrors.join(' ');
      return;
    }

    const payload: {
      recordDateTime: string;
      gmid: string;
      itemDescription: string;
      cliConfig: any;
      itemID?: number;
      id?: number;
      itemId?: number;
    } = {
      recordDateTime: new Date().toISOString(),
      gmid: this.user.gmid,
      itemDescription: this.description,
      cliConfig: this.serializeObjects(this.objects)
    };

    const resolvedItemId = this.resolveItemId();
    payload.itemID = resolvedItemId;
    payload.id = resolvedItemId;
    payload.itemId = resolvedItemId;

    if (this.dataIn?.editing) {
      // this._cart.updateCart(payload).subscribe({
      //   next: (response: any) => {
      //     console.log('Cart updated successfully:', response);
      //     this.dialogRef?.close(response);
      //   },
      //   error: (error: any) => {
      //     console.error('Failed to update cart:', error);
      //     this.errorMessage = this.handleCartError(error);
      //   }
      // });
      return;
    }

    if (this.dataIn?.submission) {
      this.dialogRef?.close(payload);
      return;
    }

    // this._cart.postObjToCart(payload).subscribe({
    //   next: (response: any) => {
    //     console.log('Cart posted successfully:', response);
    //     this.dialogRef?.close(response);
    //   },
    //   error: (error: any) => {
    //     console.error('Failed to post cart:', error);
    //     this.errorMessage = this.handleCartError(error);
    //   }
    // });
  }

  addObject() {
    let parent = '';
    if (this.hasStartingParent) parent = this.startingParent.value;
    this.objects.push({
      value: '',
      type: '',
      parent: parent
    });
  }

  addGroup() {
    let parent = '';
    if (this.hasStartingParent) parent = this.startingParent.value;
    this.objects.push({
      value: '',
      type: 'group',
      parent: parent,
      children: []
    });
  }

  private ensureInitialTrailingBlanks() {
    if (!Array.isArray(this.objects)) return;
    for (const o of this.objects) {
      if (Array.isArray(o?.memberGroups)) {
        this.ensureOneTrailingBlank(o.memberGroups, 'group');
      }
      if (Array.isArray(o?.memberObjects)) {
        this.ensureOneTrailingBlank(o.memberObjects, '');
      }
    }
  }

  // addChildToGroup(parentObj: any, isGroup = false) {
  //   if (!parentObj.value || parentObj.value == '') {
  //     console.error('Parent object must have a value before adding a child group.');
  //     return;
  //   }
  //   console.log('Adding child to parent:', parentObj);
  //   if (isGroup) {
  //     parentObj.children.push({
  //       value: '',
  //       type: 'group',
  //       parent: parentObj.value,
  //       children: []
  //     });
  //   } else {
  //     parentObj.children.push({
  //       value: '',
  //       type: '',
  //       parent: parentObj.value
  //     });
  //   }
  // }

  onChangeInputObject(obj: any) {
    console.log('Input changed:', obj.value);
    obj.type = this.matchInputType(obj.value);
    this.invalidObjects.delete(obj);
    this.errorMessage = '';
    // Need to check db for duplicates
  }

  onChangeInputGroup(obj: any) {
    console.log('Group input changed:', obj.value);
    // As user types hit ASMS info to find value they are looking for and show below as clickable options
    // User will need to also include a shortname to combine with ASMS 
    // Check for duplicates
    this.updateChildrenParentName(obj);
    this.invalidObjects.delete(obj);
    this.errorMessage = '';
  }

  onInputChange(obj: any, list?: any[], typeHint?: string) {
    if (!obj) return;
    const isGroup = (obj.type === 'group') || typeHint === 'group';
    if (isGroup) {
      this.onChangeInputGroup(obj);
    } else {
      this.onChangeInputObject(obj);
    }
    this.ensureOneTrailingBlank(list, isGroup ? 'group' : (typeHint ?? obj.type ?? ''));
  }

  private ensureOneTrailingBlank(list?: any[], typeHint: string = '') {
    if (!Array.isArray(list)) return;
    // Remove any blanks except the last one
    for (let i = list.length - 2; i >= 0; i--) {
      const v = (list[i]?.value ?? '').toString().trim();
      if (v === '') {
        list.splice(i, 1);
      }
    }
    const last = list[list.length - 1];
    const lastBlank = !last || (typeof last.value === 'string' ? last.value.trim() === '' : last.value === '' || last.value === undefined);
    if (!last || !lastBlank) {
      list.push({ value: '', type: typeHint || '' });
    }
  }

  updateChildrenParentName(group: any) {
    if (!group.children) return;
    for (const child of group.children) {
      child.parent = group.value;
      if (child.type === 'group') {
        this.updateChildrenParentName(child);
      }
    }
  }


  matchInputType(input: string): string | null {
    const ip = '(?:25[0-5]|2[0-4]\\d|1?\\d{1,2})';
    const ipV4 = `(?:${ip}\\.){3}${ip}`;
    const regexPatterns: { [key: string]: RegExp } = {
      fqdn: /^(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/,
      host: new RegExp(`^${ipV4}$`),
      subnet: /^\s*(\d{1,3}\.){3}\d{1,3}(\s+(255|254|252|248|240|224|192|128|0)\.(255|254|252|248|240|224|192|128|0)\.(255|254|252|248|240|224|192|128|0)\.(0|128|192|224|240|248|252|254|255)|\/([8-9]|[1-2][0-9]|3[0-2]))\s*$/,
      // Accept: "10.0.0.1 10.0.0.2", "10.0.0.1-10.0.0.2", "r-10.0.0.1-10.0.0.2", optional "Range:" prefix
      range: new RegExp(`^\\s*(?:range\\s*:\\s*)?(?:r\\s*-\\s*)?(${ipV4})\\s*(?:-|\\s+)\\s*(${ipV4})\\s*$`, 'i')
    };

    // Check each pattern
    for (const type in regexPatterns) {
      if (regexPatterns[type].test(input)) {
        return type;
      }
    }

    return 'unknown';
  }
 
  // removeObject(obj: any) {
  //   const hasChildren = obj.type === 'group' && obj.children && obj.children.length > 0;
    
  //   let confirmMessage = `Are you sure you want to delete "${obj.value}"?`;
  //   if (hasChildren) {
  //     confirmMessage += ` This will also delete all ${obj.children.length} child item(s).`;
  //   }
    
  //   if (confirm(confirmMessage)) {
  //     this.deleteObjectRecursively(obj);
  //   }
  // }

  // deleteObjectRecursively(objToDelete: any) {
  //   // Remove from top-level objects array
  //   this.objects = this.objects.filter((obj: any) => obj !== objToDelete);
  //   this.removeInvalidRecursive(objToDelete);
    
  //   // Remove from any parent's children array
  //   this.removeFromParentChildren(this.objects, objToDelete);
  // }

  // removeFromParentChildren(objectsArray: any[], objToDelete: any) {
  //   objectsArray.forEach(obj => {
  //     if (obj.type === 'group' && obj.children) {
  //       obj.children = obj.children.filter((child: any) => child !== objToDelete);
  //       // Recursively check nested children
  //       this.removeFromParentChildren(obj.children, objToDelete);
  //     }
  //   });
  // }

  isInvalid(obj: any): boolean {
    return this.invalidObjects.has(obj);
  }

  private validateObjects(items: any[]): string[] {
    const messages = new Set<string>();

    const traverse = (list: any[], lineage: string[]): void => {
      list.forEach((item, index) => {
        if (!item) {
          return;
        }

        const value = typeof item.value === 'string' ? item.value.trim() : item.value;
        const label = value || `Item ${index + 1}`;

        if (!value) {
          messages.add(`Provide a name for ${[...lineage, label].join(' › ')}.`);
          this.invalidObjects.add(item);
        }

        if (item.type !== 'group') {
          if (!item.type || !this.allowedObjectTypes.has(item.type)) {
            messages.add(`Enter a valid host, range, subnet, or FQDN for ${[...lineage, label].join(' › ')}.`);
            this.invalidObjects.add(item);
          }
        } else {
          if (!Array.isArray(item.children)) {
            item.children = [];
          }
          traverse(item.children, [...lineage, label]);
        }
      });
    };

    traverse(items, this.hasStartingParent ? [this.startingParent.value] : []);
    return Array.from(messages);
  }

  private serializeObjects(items: any[]): any[] {
    return items.map(item => {
      const trimmedValue = typeof item.value === 'string' ? item.value.trim() : item.value;
      const base: any = {
        value: trimmedValue,
        type: item.type,
        parent: item.parent ?? ''
      };

      if (item.type === 'group') {
        base.children = this.serializeObjects(Array.isArray(item.children) ? item.children : []);
      }

      return base;
    });
  }

  private removeInvalidRecursive(obj: any) {
    if (!obj) {
      return;
    }

    this.invalidObjects.delete(obj);

    if (obj.children && Array.isArray(obj.children)) {
      obj.children.forEach((child: any) => this.removeInvalidRecursive(child));
    }
  }

  // private handleCartError(error: any): string {
  //   if (error?.status === 400) {
  //     return 'The ASA cart request is missing required information. Please review your entries and try again.';
  //   }

  //   if (error?.status === 409) {
  //     return 'A cart item with this ID already exists. Update the existing entry or choose a different identifier.';
  //   }

  //   return 'Unable to save to cart right now. Verify the object details or try again shortly.';
  // }

  private resolveItemId(): number {
    const candidateSources = [
      this.dataIn?.itemID,
      this.dataIn?.itemId,
      this.dataIn?.id
    ];

    for (const source of candidateSources) {
      const parsed = typeof source === 'number' ? source : Number.parseInt(source as any, 10);
      if (Number.isFinite(parsed) && parsed > 0 && parsed <= 2147483647) {
        return parsed;
      }
    }

    if (this.user?.gmid) {
      const timeSeed = Math.floor(Date.now() / 1000);
      const gmidSuffix = Number.parseInt(String(this.user.gmid).slice(-3), 10);
      const suffix = Number.isFinite(gmidSuffix) ? gmidSuffix : Math.floor(Math.random() * 900) + 100;
      const candidate = Number(`${timeSeed}${suffix}`.slice(0, 9));
      if (Number.isFinite(candidate) && candidate > 0 && candidate <= 2147483647) {
        return candidate;
      }
    }

    const fallback = (Date.now() % 2146000000) + 1;
    return Math.floor(fallback);
  }
}
